var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02666 0.558134C7.11648 0.29846 7.48372 0.298459 7.57354 0.558133L8.96149 4.57093C9.00181 4.6875 9.11159 4.76569 9.23493 4.76569H13.6861C13.9707 4.76569 14.0843 5.13354 13.8492 5.294L10.2799 7.73007C10.1721 7.80364 10.1269 7.94028 10.1696 8.06362L11.5401 12.0262C11.6312 12.2896 11.3338 12.5168 11.1036 12.3597L7.4632 9.87512C7.36483 9.80798 7.23536 9.80798 7.13699 9.87512L3.49662 12.3597C3.2664 12.5168 2.96896 12.2896 3.06007 12.0262L4.43064 8.06362C4.47331 7.94028 4.42811 7.80364 4.32031 7.73006L0.751034 5.294C0.515929 5.13354 0.629496 4.76569 0.914139 4.76569H5.36526C5.4886 4.76569 5.59838 4.6875 5.6387 4.57093L7.02666 0.558134Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarUnfilled);
export default __webpack_public_path__ + "static/media/star-unfilled.2d684c06ad48cd37f52ca1eb83e7771a.svg";
export { ForwardRef as ReactComponent };